export const appearanceFeatureFlags = {
  globalSearch: 'global-search',
  toolbarNotifications: 'appearance.toolbarNotifications',
  toolbarHelp: 'appearance.toolbarHelp',
  sidebarFeedback: 'appearance.sidebarFeedback',
  lightModeDefault: 'appearance.lightModeDefault',
  themeModeToggle: 'appearance.themeModeToggle',
} as const;

export const appAppearanceFeatureFlagKeys = [
  appearanceFeatureFlags.globalSearch,
  appearanceFeatureFlags.toolbarNotifications,
  appearanceFeatureFlags.toolbarHelp,
  appearanceFeatureFlags.sidebarFeedback,
  appearanceFeatureFlags.themeModeToggle,
] as const;

export const superuserAppearanceFeatureFlagKeys = [
  appearanceFeatureFlags.globalSearch,
  appearanceFeatureFlags.toolbarNotifications,
  appearanceFeatureFlags.toolbarHelp,
  appearanceFeatureFlags.sidebarFeedback,
  appearanceFeatureFlags.lightModeDefault,
  appearanceFeatureFlags.themeModeToggle,
] as const;

export const isFeatureFlagEnabled = (
  flags: Record<string, boolean> | null | undefined,
  key: string,
): boolean => flags?.[key] === true;
